import { GoCheckCircleFill } from "react-icons/go";
import { GoCircle } from "react-icons/go";

import styles from "./toolbox-components.module.css";

interface ToolboxComponentCheckboxProps {
  text: string;
  isSelected: boolean;
  onClick: () => void;
}

export const ToolboxComponentCheckbox = (
  props: ToolboxComponentCheckboxProps
) => {
  return (
    <div
      className={styles.checkboxContainer}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.isSelected ? (
        <GoCheckCircleFill className={styles.checkboxIcon} />
      ) : (
        <GoCircle className={styles.checkboxIcon} />
      )}
      <span className={styles.checkboxText}>{props.text}</span>
    </div>
  );
};
